import React, {useCallback, useEffect, useRef, useState} from "react";
import {Tooltip} from "@mui/material";
import LazySvg from "../lazy-svg";
import LazyImage from "../lazy-image";
import {getTagIconFileName} from "./normalize-product-tags";

const ProductTagChip = ({
                              tag,
                              iconSize = 24,
                              chipClassName = 'chips',
                              labelClassName = 'product-tag-chip-label',
                              onTagReady,
                              onTagClicked,
                          }) => {
    const fileName = getTagIconFileName(tag);
    const [iconErrored, setIconErrored] = useState(false);
    const hasSignaledReady = useRef(false);
    const showIcon = !!fileName && !iconErrored;
    const isPng = fileName?.toLowerCase()?.endsWith('.png');

    const signalReady = useCallback(() => {
        if (hasSignaledReady.current)
            return;
        hasSignaledReady.current = true;
        onTagReady?.();
    }, [onTagReady]);

    useEffect(() => {
        hasSignaledReady.current = false;
        setIconErrored(false);
    }, [fileName, tag?.id]);

    useEffect(() => {
        if (!fileName) {
            signalReady();
        }
    }, [fileName, signalReady]);

    const handleLoad = useCallback(() => signalReady(), [signalReady]);
    const handleError = useCallback(() => {
        setIconErrored(true);
        signalReady();
    }, [signalReady]);

    return (
        <Tooltip title={tag?.name ?? ''} placement={'bottom'} arrow>
            <div
                className={chipClassName}
                data-product-tag-chip
                {...(onTagClicked && {onClick: (e) => onTagClicked(e, tag)})}
            >
                {
                    showIcon &&
                    (
                        isPng
                            ? <LazyImage
                                src={fileName}
                                height={iconSize}
                                width={iconSize}
                                onError={handleError}
                                onLoad={handleLoad}
                            />
                            : <LazySvg
                                src={fileName}
                                height={iconSize}
                                width={iconSize}
                                onError={handleError}
                                onLoad={handleLoad}
                            />
                    )
                }
                <span className={labelClassName}>
                    {tag?.name ?? ''}
                </span>
            </div>
        </Tooltip>
    );
};

export default ProductTagChip;
